/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFilterTransform } from '../../factoriesAny.js';
export var filterTransformDependencies = {
  typedDependencies,
  createFilterTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFilterTransform.generated.js
// module id = 1365
// module chunks = 2